<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				CLIENTES
			</template>

			<template v-slot:subtitle> 
				CLIENTES
			</template>


			<template v-slot:content>

				<div id="cms-clientes">
					
					<v-container>

						<v-card light v-if="customers != null">

					    <v-card-title>
					      <v-text-field
					        v-model="search"
					        append-icon="mdi-magnify"
					        label="Buscar"
					        single-line
					        hide-details
					      ></v-text-field>
					    </v-card-title>
					    
					    <v-data-table
					      :headers="headers"
					      :items="customers"
					      :search="search"
					    >

					    	<template v-slot:item.phone="{ item }">
					    	  {{phoneFormat(item.phone)}}
					    	</template>
					    	
					    	<template v-slot:item.actions="{ item }">
					    	  <v-icon
					    	    @click="deleteCustomer(item)"
					    	  >
					    	    mdi-delete
					    	  </v-icon>
					    	</template>

					    </v-data-table>
					  
					  </v-card>

					</v-container>

				</div>

		  </template>

		</layout>

	</div>
</template>


<style>
	
	

</style>


<script>
	
	import Layout from './../../layout/Layout'
	import CustomerService from '@/shared/services/CustomerService'


	export default
	{

		data() {
			return {
				search: '',
        headers: [
          { text: 'Nombre completo', align: 'start', filterable: true, value: 'name' },
          { text: 'Negocio', value: 'name_business' },
          { text: 'Teléfono', value: 'phone', sortable: true },
          { text: 'Correo eléctronico', value: 'email' },
          { text: 'Opciones', value: 'actions', sortable: false },
        ],
        customers:null,
			}
		},

		components: {
			Layout
		},

		created() {
			this.getCustomers()
		},

		methods: {

			async getCustomers()
			{
				const resp = await CustomerService.get()
				this.customers = resp.data
			},


			async deleteCustomer(customer)
			{
				SwalQuestion('', '¿Estas seguro(a) que deseas eliminar?', async resp =>
    		{
    			if(resp.isConfirmed)
    			{
    				const resp = await CustomerService.delete(customer.user_id)

    				if(resp.data == 'OK')
    				{
    					SwalMixin('Cliente eliminado', 'success')
    					this.getCustomers()
    				}
    				else
    					SwalMixin('Ha ocurrido un error, por favor intenta de nuevo', 'error')
    			}
    		})
			}

		}

	}

</script>